"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var IndexedDb = /** @class */ (function () {
    function IndexedDb() {
        var _this = this;
        this.connect = function () { return __awaiter(_this, void 0, void 0, function () {
            var databaseRequest;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.database)
                            return [2 /*return*/, this.database];
                        return [4 /*yield*/, indexedDB.open(constants_1.INDEXED_DB_NAME, 2)];
                    case 1:
                        databaseRequest = _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                databaseRequest.onupgradeneeded = function (event) {
                                    _this.database = event.target.result;
                                    var objectStore = _this.database.createObjectStore(constants_1.OBJECT_STORE, { keyPath: 'hash' });
                                    objectStore.createIndex('name', 'name', { unique: false });
                                    objectStore.createIndex('type', 'type', { unique: false });
                                    objectStore.createIndex('lastModified', 'lastModified', { unique: false });
                                    objectStore.createIndex('file', 'file', { unique: false });
                                    resolve(_this.database);
                                };
                                databaseRequest.onsuccess = function (event) {
                                    _this.database = event.target.result;
                                    resolve(_this.database);
                                    _this.database.onversionchange = function () {
                                        _this.database.close();
                                        window.location.reload();
                                        throw new Error('Indexed DB must be updated. Page will be reloaded ...');
                                    };
                                };
                                databaseRequest.onblocked = function (event) {
                                    reject(event);
                                    throw new Error('Indexed DB is blocked. It seems that there is another open connection.');
                                };
                                databaseRequest.onerror = function (event) {
                                    reject(event);
                                    throw new Error('Indexed DB could not be opened.');
                                };
                            })];
                }
            });
        }); };
        this.getAll = function () { return __awaiter(_this, void 0, void 0, function () {
            var connection, objectStore, request;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.connection];
                    case 1:
                        connection = _a.sent();
                        objectStore = connection.transaction(constants_1.OBJECT_STORE, 'readwrite').objectStore(constants_1.OBJECT_STORE);
                        request = objectStore.getAll();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                request.onsuccess = function () { return resolve(request.result); };
                                request.onerror = function () { return reject(request.result); };
                            })];
                }
            });
        }); };
        this.get = function (uid) { return __awaiter(_this, void 0, void 0, function () {
            var connection, objectStore, request;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.connection];
                    case 1:
                        connection = _a.sent();
                        objectStore = connection.transaction(constants_1.OBJECT_STORE, 'readwrite').objectStore(constants_1.OBJECT_STORE);
                        request = objectStore.get(uid);
                        return [2 /*return*/, this.requestHandler(request)];
                }
            });
        }); };
        this.add = function (item) { return __awaiter(_this, void 0, void 0, function () {
            var connection, objectStore, request;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.connection];
                    case 1:
                        connection = _a.sent();
                        objectStore = connection.transaction(constants_1.OBJECT_STORE, 'readwrite').objectStore(constants_1.OBJECT_STORE);
                        request = objectStore.put(item);
                        return [2 /*return*/, this.requestHandler(request)];
                }
            });
        }); };
        this.remove = function (uid) { return __awaiter(_this, void 0, void 0, function () {
            var connection, objectStore, request;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.connection];
                    case 1:
                        connection = _a.sent();
                        objectStore = connection.transaction(constants_1.OBJECT_STORE, 'readwrite').objectStore(constants_1.OBJECT_STORE);
                        request = objectStore.delete(uid);
                        return [2 /*return*/, this.requestHandler(request)];
                }
            });
        }); };
        this.clear = function () { return __awaiter(_this, void 0, void 0, function () {
            var connection, objectStore, request;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.connection];
                    case 1:
                        connection = _a.sent();
                        objectStore = connection.transaction(constants_1.OBJECT_STORE, 'readwrite').objectStore(constants_1.OBJECT_STORE);
                        request = objectStore.clear();
                        return [2 /*return*/, this.requestHandler(request)];
                }
            });
        }); };
        this.hash = (function (data) { return __awaiter(_this, void 0, void 0, function () {
            var uint8Array, _a, hashBuffer, hashArray;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = Uint8Array.bind;
                        return [4 /*yield*/, data.arrayBuffer()];
                    case 1:
                        uint8Array = new (_a.apply(Uint8Array, [void 0, _b.sent()]))();
                        return [4 /*yield*/, crypto.subtle.digest('SHA-256', uint8Array)];
                    case 2:
                        hashBuffer = _b.sent();
                        hashArray = Array.from(new Uint8Array(hashBuffer));
                        return [2 /*return*/, hashArray.map(function (h) { return h.toString(16).padStart(2, '0'); }).join('')];
                }
            });
        }); });
        if (!this.connection) {
            this.connection = this.connect();
        }
    }
    IndexedDb.prototype.requestHandler = function (request) {
        return new Promise(function (resolve, reject) {
            request.onsuccess = function () { return resolve(request.result); };
            request.onerror = function () { return reject(request.result); };
        });
    };
    return IndexedDb;
}());
exports.default = IndexedDb;
